import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { sentryCapture } from '@/utils/sentry'

declare global {
  interface Window {
    grecaptcha?: any
  }
}

export const useRecaptchaStore = defineStore('RecaptchaStore', () => {
  const recaptchaToken = ref('')

  const getToken = computed(() => recaptchaToken.value)

  const sendRecaptcha = (): Promise<boolean> => {
    const recaptchaSiteKey = import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY

    return new Promise(resolve => {
      try {
        window.grecaptcha.enterprise.ready(() => {
          window.grecaptcha.enterprise
            .execute(recaptchaSiteKey, { action: 'submit' })
            .then((token: string) => {
              recaptchaToken.value = token
              resolve(true)
            })
            .catch((err: unknown) => {
              sentryCapture(err)
              resolve(false)
            })
        })
      } catch (error) {
        resolve(false)
      }
    })
  }

  const removeRecaptcha = () => (recaptchaToken.value = '')

  return {
    getToken,
    recaptchaToken,
    removeRecaptcha,
    sendRecaptcha
  }
})
